<template>
  <div
    class="title-editor"
    :class="{ 'red-border': showRedBorder }"
  >
    <InlineEditor
      v-bind="{ ...$props, ...$attrs }"
      :editor-id="'title'"
      @ai-suggest-click="$emit('aiSuggestClick', $event)"
      @add-editor="$emit('addEditor', $event)"
      @blur-editor="$emit('blurEditor', $event)"
      @remove-editor="$emit('removeEditor', $event)"
      @update-selected-json="$emit('updateSelectedJson', $event)"
      @focus-editor="$emit('focusEditor', $event)"
    />
  </div>
</template>

<script>
import InlineEditor from '@ui/components/editor/InlineEditor/InlineEditor.vue';
import { tiptapWrapProps } from '@ui/components/editor/TiptapWrap/tiptapWrapProps';

export default {
  name: 'TitleEditor',
  components: { InlineEditor },
  props: {
    ...tiptapWrapProps,
    showRedBorder: { type: Boolean, default: false },
  },
  emits: [
    'aiSuggestClick',
    'addEditor',
    'blurEditor',
    'removeEditor',
    'updateSelectedJson',
    'focusEditor',
  ],
};
</script>

<style scoped lang="less">
.title-editor :deep(.ProseMirror) {
  p {
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.5px;
  }
}

.title-editor {
  &.red-border {
    border: 5px solid red;
  }
}
</style>
